const roles = [
  {
    id: 'software-engineering',
    category: 'category1.name',
    roles: [
      {
        name: 'category1.roles.role1_text',
        desc: 'category1.roles.role1_desc'
      },
      {
        name: 'category1.roles.role2_text',
        desc: 'category1.roles.role2_desc'
      },
      {
        name: 'category1.roles.role3_text',
        desc: 'category1.roles.role3_desc'
      },
      {
        name: 'category1.roles.role4_text',
        desc: 'category1.roles.role4_desc'
      },
      {
        name: 'category1.roles.role5_text',
        desc: 'category1.roles.role5_desc'
      },
      {
        name: 'category1.roles.role6_text',
        desc: 'category1.roles.role6_desc'
      },
      {
        name: 'category1.roles.role7_text',
        desc: 'category1.roles.role7_desc'
      },
      {
        name: 'category1.roles.role8_text',
        desc: 'category1.roles.role8_desc'
      },
      {
        name: 'category1.roles.role9_text',
        desc: 'category1.roles.role9_desc'
      },
      {
        name: 'category1.roles.role91_text',
        desc: 'category1.roles.role91_desc'
      },
      {
        name: 'category1.roles.role10_text',
        desc: 'category1.roles.role10_desc'
      },
      {
        name: 'category1.roles.role11_text',
        desc: 'category1.roles.role11_desc'
      },
      {
        name: 'category1.roles.role12_text',
        desc: 'category1.roles.role12_desc'
      },
      {
        name: 'category1.roles.role13_text',
        desc: 'category1.roles.role13_desc'
      },
      {
        name: 'category1.roles.role14_text',
        desc: 'category1.roles.role14_desc'
      },
      {
        name: 'category1.roles.role15_text',
        desc: 'category1.roles.role15_desc'
      },
      {
        name: 'category1.roles.role16_text',
        desc: 'category1.roles.role16_desc'
      },
      {
        name: 'category1.roles.role161_text',
        desc: 'category1.roles.role161_desc'
      },
      {
        name: 'category1.roles.role17_text',
        desc: 'category1.roles.role17_desc'
      },
      {
        name: 'category1.roles.role18_text',
        desc: 'category1.roles.role18_desc'
      }
    ]
  },
  {
    id: 'data',
    category: 'category2.name',
    roles: [
      {
        name: 'category2.roles.role1_text',
        desc: 'category2.roles.role1_desc'
      },
      {
        name: 'category2.roles.role2_text',
        desc: 'category2.roles.role2_desc'
      },
      {
        name: 'category2.roles.role3_text',
        desc: 'category2.roles.role3_desc'
      },
      {
        name: 'category2.roles.role4_text',
        desc: 'category2.roles.role4_desc'
      }
    ]
  },
  {
    id: 'other-engineering',
    category: 'category3.name',
    roles: [
      {
        name: 'category3.roles.role1_text',
        desc: 'category3.roles.role1_desc'
      },
      {
        name: 'category3.roles.role2_text',
        desc: 'category3.roles.role2_desc'
      },
      {
        name: 'category3.roles.role3_text',
        desc: 'category3.roles.role3_desc'
      },
      {
        name: 'category3.roles.role4_text',
        desc: 'category3.roles.role4_desc'
      }
    ]
  },
  {
    id: 'product',
    category: 'category4.name',
    roles: [
      {
        name: 'category4.roles.role1_text',
        desc: 'category4.roles.role1_desc'
      },
      {
        name: 'category4.roles.role2_text',
        desc: 'category4.roles.role2_desc'
      },
      {
        name: 'category4.roles.role3_text',
        desc: 'category4.roles.role3_desc'
      },
      {
        name: 'category4.roles.role4_text',
        desc: 'category4.roles.role4_desc'
      },
      {
        name: 'category4.roles.role5_text',
        desc: 'category4.roles.role5_desc'
      },
      {
        name: 'category4.roles.role6_text',
        desc: 'category4.roles.role6_desc'
      }
    ]
  },
  {
    id: 'design',
    category: 'category5.name',
    roles: [
      {
        name: 'category5.roles.role1_text',
        desc: 'category5.roles.role1_desc'
      },
      {
        name: 'category5.roles.role2_text',
        desc: 'category5.roles.role2_desc'
      },
      {
        name: 'category5.roles.role3_text',
        desc: 'category5.roles.role3_desc'
      },
      {
        name: 'category5.roles.role4_text',
        desc: 'category5.roles.role4_desc'
      },
      {
        name: 'category5.roles.role5_text',
        desc: 'category5.roles.role5_desc'
      },
      {
        name: 'category5.roles.role6_text',
        desc: 'category5.roles.role6_desc'
      },
      {
        name: 'category5.roles.role7_text',
        desc: 'category5.roles.role7_desc'
      },
      {
        name: 'category5.roles.role8_text',
        desc: 'category5.roles.role8_desc'
      },
      {
        name: 'category5.roles.role9_text',
        desc: 'category5.roles.role9_desc'
      }
    ]
  },
  {
    id: 'marketing',
    category: 'category6.name',
    roles: [
      {
        name: 'category6.roles.role1_text',
        desc: 'category6.roles.role1_desc'
      },
      {
        name: 'category6.roles.role2_text',
        desc: 'category6.roles.role2_desc'
      },
      {
        name: 'category6.roles.role3_text',
        desc: 'category6.roles.role3_desc'
      },
      {
        name: 'category6.roles.role4_text',
        desc: 'category6.roles.role4_desc'
      },
      {
        name: 'category6.roles.role5_text',
        desc: 'category6.roles.role5_desc'
      },
      {
        name: 'category6.roles.role6_text',
        desc: 'category6.roles.role6_desc'
      },
      {
        name: 'category6.roles.role7_text',
        desc: 'category6.roles.role7_desc'
      },
      {
        name: 'category6.roles.role8_text',
        desc: 'category6.roles.role8_desc'
      },
      {
        name: 'category6.roles.role9_text',
        desc: 'category6.roles.role9_desc'
      },
      {
        name: 'category6.roles.role10_text',
        desc: 'category6.roles.role10_desc'
      }
    ]
  },
  {
    id: 'operations-and-strategy',
    category: 'category7.name',
    roles: [
      {
        name: 'category7.roles.role1_text',
        desc: 'category7.roles.role1_desc'
      },
      {
        name: 'category7.roles.role2_text',
        desc: 'category7.roles.role2_desc'
      },
      {
        name: 'category7.roles.role3_text',
        desc: 'category7.roles.role3_desc'
      },
      {
        name: 'category7.roles.role4_text',
        desc: 'category7.roles.role4_desc'
      },
      {
        name: 'category7.roles.role5_text',
        desc: 'category7.roles.role5_desc'
      },
      {
        name: 'category7.roles.role6_text',
        desc: 'category7.roles.role6_desc'
      }
    ]
  },
  {
    id: 'sales-and-account-management',
    category: 'category8.name',
    roles: [
      {
        name: 'category8.roles.role1_text',
        desc: 'category8.roles.role1_desc'
      },
      {
        name: 'category8.roles.role2_text',
        desc: 'category8.roles.role2_desc'
      },
      {
        name: 'category8.roles.role3_text',
        desc: 'category8.roles.role3_desc'
      },
      {
        name: 'category8.roles.role4_text',
        desc: 'category8.roles.role4_desc'
      },
      {
        name: 'category8.roles.role5_text',
        desc: 'category8.roles.role5_desc'
      },
      {
        name: 'category8.roles.role6_text',
        desc: 'category8.roles.role6_desc'
      }
    ]
  },
  {
    id: 'people-hr-recruiting',
    category: 'category9.name',
    roles: [
      {
        name: 'category9.roles.role1_text',
        desc: 'category9.roles.role1_desc'
      },
      {
        name: 'category9.roles.role2_text',
        desc: 'category9.roles.role2_desc'
      },
      {
        name: 'category9.roles.role3_text',
        desc: 'category9.roles.role3_desc'
      }
    ]
  },
  {
    id: 'finance-legal-and-compliance',
    category: 'category10.name',
    roles: [
      {
        name: 'category10.roles.role1_text',
        desc: 'category10.roles.role1_desc'
      },
      {
        name: 'category10.roles.role2_text',
        desc: 'category10.roles.role2_desc'
      },
      {
        name: 'category10.roles.role3_text',
        desc: 'category10.roles.role3_desc'
      },
      {
        name: 'category10.roles.role4_text',
        desc: 'category10.roles.role4_desc'
      },
      {
        name: 'category10.roles.role5_text',
        desc: 'category10.roles.role5_desc'
      },
      {
        name: 'category10.roles.role6_text',
        desc: 'category10.roles.role6_desc'
      }
    ]
  }
];

export default roles;
